// extracted by mini-css-extract-plugin
module.exports = {"NotificationBox":"NotificationBox_NotificationBox__3K-Rj","Closed":"NotificationBox_Closed__3BARC","Open":"NotificationBox_Open__3dncZ"};